const gains = [
  { icon: "ri-eye-line", label: "Visibility" },
  { icon: "ri-shield-check-line", label: "Control" },
  { icon: "ri-user-follow-line", label: "Accountability" },
  { icon: "ri-flashlight-line", label: "Efficiency" },
  { icon: "ri-coins-line", label: "Revenue assurance" },
  { icon: "ri-bar-chart-grouped-line", label: "Better decisions" },
];

export default function GainsSection() {
  return (
    <section className="relative py-16 md:py-24 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            What You <span className="text-emerald-accent">Gain</span>
          </h2>
          <p className="text-silver-300 text-base md:text-lg max-w-2xl mx-auto">
            Moving to StackMap transforms how your business operates at every level.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4 max-w-4xl mx-auto">
          {gains.map((g) => (
            <div key={g.label} className="glass-card p-5 md:p-6 flex flex-col items-center text-center gap-3 group">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-graphite-800 group-hover:bg-emerald-accent/10 transition-colors">
                <i className={`${g.icon} text-xl md:text-2xl text-emerald-accent group-hover:scale-110 transition-transform duration-300`} />
              </div>
              <span className="text-sm md:text-base font-medium text-white group-hover:text-emerald-soft transition-colors duration-300">{g.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}